/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if (this.collection_layout == 'slider') {
      this.createSlider($section.find('.slider-gallery--desktop'), this.products_per);
    }

    if (this.collection_layout_mobile == 'slider') {
      this.createSlider($section.find('.slider-gallery--mobile'), this.mobile_products_per_row);
    }
  },
  createSlider: function(slider, productsPerSlide) {
    const productsAvailable = slider.find('.gallery-cell').length;

    if (productsAvailable <= productsPerSlide) {
      slider.addClass('container is-justify-center');
      slider.find('.gallery-cell').addClass('column');
      return;
    }

    $(slider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: productsAvailable > productsPerSlide,
      initialIndex: 0,
      arrowShape: 'M65 80 L35 50 L65 20',
    });

    $(slider).on('settle.flickity', () => $(slider).flickity('resize'));
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;